import { css } from 'styled-components';

import { mq } from '../styles/grid';

/**
 * @param {SpacingType} skin - The skin type for spacing.
 * @param {spacingOrientation} orientation - The orientation for spacing.
 * @returns {FlattenInterpolation<{ theme: Theme }>} - The styled-components interpolation for spacing
 */
const getSpacing = (skin, orientation = 'mbottom') => {
  switch (orientation) {
    case 'mtop':
      return css`
        margin-top: ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          margin-top: ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'mbottom':
      return css`
        margin-bottom: ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          margin-bottom: ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'mx':
      return css`
        margin: 0 ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          margin: 0 ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'my':
      return css`
        margin: ${(props) => props.theme.spacing.xl[skin]} 0;

        @media (${mq.smDown}) {
          margin: ${(props) => props.theme.spacing.xs[skin]} 0;
        }
      `;
    case 'ptop':
      return css`
        padding-top: ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          padding-top: ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'pbottom':
      return css`
        padding-bottom: ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          padding-bottom: ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'px':
      return css`
        padding: 0 ${(props) => props.theme.spacing.xl[skin]};

        @media (${mq.smDown}) {
          padding: 0 ${(props) => props.theme.spacing.xs[skin]};
        }
      `;
    case 'py':
      return css`
        padding: ${(props) => props.theme.spacing.xl[skin]} 0;

        @media (${mq.smDown}) {
          padding: ${(props) => props.theme.spacing.xs[skin]} 0;
        }
      `;
    case 'py-bottom-doubled':
      return css`
        padding: ${(props) => props.theme.spacing.xl[skin]} 0
          calc(2 * ${(props) => props.theme.spacing.xl[skin]}) 0;

        @media (${mq.smDown}) {
          padding: ${(props) => props.theme.spacing.xs[skin]} 0;
        }
      `;
    default:
      throw Error(`Unsupported spacing orientation: ${orientation}`); // should be never reached
  }
};

export default getSpacing;
